let baseUrl = 'https://fm-api-dev.falconweb.app/api/v1';
let nodeUrl = 'https://fmnode-api-dev.falconweb.app';
if (window.location.host === 'fm-dev.falconweb.app') {
  nodeUrl = 'https://fmnode-api-dev.falconweb.app';
  baseUrl = 'https://fm-api-dev.falconweb.app/api/v1';
} else if (window.location.host === 'fm-qa.falconweb.app') {
  baseUrl = 'https://fm-api-qa.falconweb.app/api/v1';
  nodeUrl = 'https://fmnode-api-qa.falconweb.app';
} else if (window.location.host === 'fm-staging.falconweb.app') {
  baseUrl = 'https://fm-api-staging.falconweb.app/api/v1';
  nodeUrl = 'https://fmnode-api-staging.falconweb.app';
}
module.exports = { baseUrl, nodeUrl };
